import React from "react";
import * as XLSX from "xlsx";

const ReportExcel = ({ tableData, fileName }) => {

const convertToExcel = () => {
  try {
    if (!tableData || tableData.length === 0) {
      alert("No data available to export");
      return;
    }

    const minutesOfDayUTC = (iso) => {
      const d = new Date(iso);
      if (isNaN(d)) return null;
      return d.getUTCHours() * 60 + d.getUTCMinutes();
    };

    const inRangeModulo = (t, start, end) => {
      if (start <= end) return t >= start && t < end;
      return t >= start || t < end;
    };

    const filteredData = tableData.map((item) => {
      let formattedDate = "";

      if (item?.end) {
        const [year, month, day] = item.end.split(" ")[0].split("-");
        formattedDate = `${day}-${month}-${year}`;
      }

      let settlementReceived_7pm_7am = 0;
      let settlementPaid_7pm_7am = 0;

      let settlementReceived_7am_1pm = 0;
      let settlementPaid_7am_1pm = 0;

      let settlementReceived_1pm_7pm = 0;
      let settlementPaid_1pm_7pm = 0;

      let rollingReserveUnpaid = 0;
      let rollingReservePaid = 0;

      (item?.settlementData || []).forEach((s) => {
        // Rolling Reserve Logic (same as table)
        if (
          !s?.settlementTimeRange &&
          Number(s?.settlementAmount || 0) === 0
        ) {
          rollingReserveUnpaid += Number(s?.rrAmount || 0);
          rollingReservePaid += Number(s?.paidAmount || 0);
          return;
        }

        if (!s?.settledDate) return;

        const timeMinutes = minutesOfDayUTC(s.settledDate);

        const sevenPM = 19 * 60;
        const sevenAM = 7 * 60;
        const onePM = 13 * 60;

        if (inRangeModulo(timeMinutes, sevenPM, sevenAM)) {
          settlementReceived_7pm_7am += Number(
            s?.settlementAmount || 0
          );
          settlementPaid_7pm_7am += Number(s?.paidAmount || 0);
        }

        if (timeMinutes >= sevenAM && timeMinutes < onePM) {
          settlementReceived_7am_1pm += Number(
            s?.settlementAmount || 0
          );
          settlementPaid_7am_1pm += Number(s?.paidAmount || 0);
        }

        if (timeMinutes >= onePM && timeMinutes < sevenPM) {
          settlementReceived_1pm_7pm += Number(
            s?.settlementAmount || 0
          );
          settlementPaid_1pm_7pm += Number(s?.paidAmount || 0);
        }
      });

      return {
        Date: formattedDate,

        "# of Payin": item?.payinData?.payinCount || 0,

        "Payin Amount": Number(
          item?.payinData?.requestAmountPayin || 0
        ).toFixed(2),

        "Payin Fee": Number(
          item?.payinData?.totalComissionPayin || 0
        ).toFixed(2),

        "Rolling Reserve": Number(
          item?.payinData?.rollingReserve || 0
        ).toFixed(2),

        "# of Payout": item?.payoutData?.payoutCount || 0,

        "Payout Amount": Number(
          item?.payoutData?.requestAmountPayout || 0
        ).toFixed(2),

        "Payout Fee": Number(
          item?.payoutData?.totalComissionPayout || 0
        ).toFixed(2),

        "Chargeback Amount": Number(
          item?.chargebackData?.amount || 0
        ).toFixed(2),

        "Chargeback Penalty": Number(
          item?.chargebackData?.penalty || 0
        ).toFixed(2),

        // "Settlement Received (7PM-7AM)":
        //   settlementReceived_7pm_7am.toFixed(2),

        // "Settlement Received (7AM-1PM)":
        //   settlementReceived_7am_1pm.toFixed(2),

        // "Settlement Received (1PM-7PM)":
        //   settlementReceived_1pm_7pm.toFixed(2),

        // "Settlement Paid (7PM-7AM)":
        //   settlementPaid_7pm_7am.toFixed(2),

        // "Settlement Paid (7AM-1PM)":
        //   settlementPaid_7am_1pm.toFixed(2),

        // "Settlement Paid (1PM-7PM)":
        //   settlementPaid_1pm_7pm.toFixed(2),

        "Rolling Reserve Unpaid":
          rollingReserveUnpaid.toFixed(2),

        "Rolling Reserve Paid":
          rollingReservePaid.toFixed(2),

        // "Wallet Amount": Number(
        //   item?.walletAmount || 0
        // ).toFixed(2),
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(filteredData);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Report"
    );

    XLSX.writeFile(
      workbook,
      `${fileName || "Report"}.xlsx`
    );
  } catch (error) {
    console.error("Excel Export Error:", error);
    alert("Failed to download excel");
  }
};

  return (
    <button onClick={convertToExcel} className="exp-but">
      Download Report
    </button>
  );
};

export default ReportExcel;